import * as React from 'react';

type Component<T> = T & { displayName: string };

export const setDisplayName = <T extends React.FC>(displayName: string, component: T): Component<T> => {
  component.displayName = displayName;
  return component as Component<T>;
};
